import * as React from 'react';
export const IcFreezingDrizzle = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M10.5 15c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm7.5.5c-.5 0-1.5 1.67-1.5 2.5 0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-1-2.5-1.5-2.5zM6.5 17C6 17 5 18.67 5 19.5c0 .83.67 1.5 1.5 1.5S8 20.33 8 19.5 7 17 6.5 17zm7.5 2c-.83 0-1.5.67-1.5 1.5S13.17 22 14 22s1.5-.67 1.5-1.5S14.83 19 14 19zm5.44-10.62c.03-.21.06-.42.06-.63C19.5 5.13 17.37 3 14.75 3c-1.64 0-3.08.83-3.93 2.09A3.68 3.68 0 0010 5a3.98 3.98 0 00-3.86 3.01C6.09 8.01 6.05 8 6 8c-1.66 0-3 1.34-3 3s1.34 3 3 3h12c1.66 0 3-1.34 3-3 0-1.13-.64-2.11-1.56-2.62z'
      fill='currentColor'
    />
  </svg>
);
